import React from "react";

const logos: string[] = [
  "/isro.svg.png",
  "/mercedes.png",
  "/devananta.jpeg",
  "/iitm.svg.png",
  "/kle.jpeg",
  "/nuslogo.png",
  "/ktech.jpeg",
  "/mybharat.png",
];

const AssociationCarousel: React.FC = () => {
  const scrollingLogos = [...logos, ...logos];

  return (
    <div className="w-full bg-white py-10 overflow-hidden">
      <h2 className="text-center text-3xl font-semibold text-gray-800 mb-8">
        Associations
      </h2>

      <div className="relative w-full overflow-hidden">
        <div
          className="flex items-center gap-12 animate-scroll whitespace-nowrap"
          style={{
            width: `${scrollingLogos.length * 180}px`,
          }}
        >
          {scrollingLogos.map((logo, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-32 h-36 md:w-40 md:h-40 overflow-hidden"
            >
              <img
                src={logo}
                alt={`logo-${index}`}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-contain p-3"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AssociationCarousel;
